import moment from 'moment'
import ajax from '@/api/ajax'
import { setNearbyWaybillNo } from '@/util/waybillUtils'
import WaybillInfo from '@/pages/waybill/waybillDetail/waybill-info'
import WaybillRoute from '@/pages/waybill/waybillDetail/waybill-route'
import { getGeetestCaptcha, captchaType } from '@/util/load-geetest'
// 子单和母单共同
const rootChildCommon = {
    data() {
        return {
            showWaybillDetail: false, // 是否显示运单详情
            waybillDetailList: [], // 接口返回的运单动态列表
            opCodeMap: {
                // 运单路由状态列表
                signed: ['已签收', '80', '8000_1'],
                invalid: ['已作废', '8000_2'],
                delivery: ['派送中', '44', '34', '33', '122', '123', '630', '640', '83', '47', '634', '125', '204', '70_5', '70_7', '70_65'],
                collect: ['已揽收', '50'],
                pickedup: ['已取件', '54'],
                other: ['运送中'],
                received: ['已审单', '205'],
                picking: ['拣货中', '201'],
                picked: ['已拣货', '206'],
                packaged: ['已包装', '646'],
                delivered: ['已出库', '202']
            },
            geetestObj: null // geetest实例
        }
    },
    components: {
        WaybillInfo,
        WaybillRoute
    },
    methods: {
        // 验证收/寄手机号后四位步骤
        validateWaybillPhone(subMobile) {
            return ajax
                .phoneRoutes({
                    params: {
                        billNumbers: this.waybillNoList
                            .filter(item => !!item)
                            .map(item => item.toLocaleUpperCase())
                            .join(','),
                        subMobile,
                        app: 'route',
                        mediaSource: 'MOBILE.OWF'
                    }
                })
                .then(res => {
                    if (res && res.data && !+res.data.code) {
                        this.handleData((res.data.result && res.data.result.routes) || [])
                        this.showWaybillDetail = true
                    } else {
                        // 616，118 为提示超过限制次数，需替换提示语
                        this.$toast(res && res.data && [616, 118].indexOf(Number(res.data.code)) < 0 ? res.data.message : '网络异常，稍后重试')
                    }
                    return res && res.data && Number(res.data.code)
                })
        },
        openGeetestCaptcha(fetchData) {
            if(!this.geetestObj) {
                this.geetestObj = getGeetestCaptcha(captchaType.QUERY_WAYBILL, (res) => {
                    if(res.data) {
                        this.query(res.data, fetchData)
                    }
                })
            }
            this.geetestObj.showCaptcha().then(res => {
                if(res.code !== 'success') {
                    console.log(res.msg || '获取验证码js错误')
                }
            })
        },
        // 查询路由
        query(retJson, fetchData) {
            this.$loading('')
            this.queryWaybillNo(retJson, fetchData)
        },
        // 查询路由数据
        queryWaybillNo(retJson, fetchData) {
            const headers = {
                'x-gt-captcha-output': retJson.captcha_output,
                'x-gt-gen-time': retJson.gen_time,
                'x-gt-lot-number': retJson.lot_number,
                'x-gt-pass-token': retJson.pass_token
            }
            ajax.routes({
                params: {
                    billNumbers: fetchData
                        .filter(item => !!item)
                        .map(item => item.toLocaleUpperCase())
                        .join(','),
                    region: 'cn',
                    lang: 'sc'
                },
                headers
            })
                .then(res => {
                    if (res && res.data) {
                        const { code, result } = res.data
                        if (code === 0 && result) {
                            this.handleData(result.routes)
                        }
                    }
                })
                .finally(() => {
                    this.showWaybillDetail = true
                    this.$loading()
                })
        },
        // 接口返回的数据处理
        handleData(arr) {
            const list = arr.map(obj => this.parseData(obj))
            this.waybillDetailList = this.waybillDetailList.concat(list.filter(obj => obj !== null))
            let temp = []
            this.waybillDetailList.forEach(obj => {
                temp = [...temp, obj.id]
            })
            setNearbyWaybillNo(temp)
        },
        // 处理路由数据
        parseData(obj) {
            if (!obj) {
                return null
            }
            obj.routes = obj.routes
                .filter(routeObj => {
                    // "运单资料&签收图"的路由不显示并且已签收
                    const arr = ['运单资料&签收图', '運單資料&簽收圖', 'AWB Info & POD']
                    let display = true
                    arr.forEach(str => {
                        if (routeObj.remark.includes(str)) {
                            obj.signed = true
                            display = false
                        }
                    })
                    return display
                })
                .reverse()
            if (obj.routes.length === 0) {
                return null
            }
            return obj
        },
        // 获取对应运单号的详情
        waybillModel(no) {
            return this.waybillDetailList.find(obj => obj.id == no)
        },
        // 根据opcode获取status
        getStatusByOpcode(route) {
            let type = 'other'
            for (const [k, v] of Object.entries(this.opCodeMap)) {
                if (v.find(code => code == route.opCode)) {
                    type = k
                }
            }
            return {
                name: route.cxPackageMessage ? route.cxPackageMessage : this.opCodeMap[type][0],
                date: moment(route.scanDateTime).format('MMM Do'),
                time: moment(route.scanDateTime).format('HH:mm'),
                type
            }
        },
        // 是否是国际路由节点
        isAbroadRoute(routes) {
            if (!routes || routes.length < 1) {
                return false
            }
            return routes.some(route => route.opCode === '655' || route.opCode === '647')
        }
    }
}
export default rootChildCommon



// WEBPACK FOOTER //
// ./src/mixins/waybill/rootChildCommon.js